import { render, staticRenderFns } from "./RecommendedWorkflows.vue?vue&type=template&id=65c6e4d0&"
import script from "./RecommendedWorkflows.vue?vue&type=script&lang=js&"
export * from "./RecommendedWorkflows.vue?vue&type=script&lang=js&"
import style0 from "./RecommendedWorkflows.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports